module.exports = __webpack_public_path__ + "static/media/Inter-Bold.250894a9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Inter/Inter-Bold.ttf
// module id = 358
// module chunks = 17